/* eslint-disable no-shadow */
export enum GeofenceStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
}
